const initialState = {
    siteDetails: {},
    pantryList: [],
    totalPantriesCount: 0,
};

const pantryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'PANTRY_LIST': {
            return {
                ...state,
                siteDetails: action.payload.siteDetails,
                pantryList: action.payload.pantries,
                totalPantriesCount: action.payload.totalCount,
            };
        }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default pantryReducer;